export function topNotification() {
    if(localStorage.getItem("top-notification")){
        $(".top-notification").remove();
    }else{
        $('html, body').animate({scrollTop: 0}, 1750);
    }
    $('#notification-close svg').on('click', function () {
        var _height = $(".top-notification").height();
        $(".top-notification").css('margin-top', '-' + _height + 'px');
        localStorage.setItem('top-notification', 1);
        setTimeout(function () {
            $(".top-notification").css('margin', 0).hide();
        }, 2000)
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/top-notification.js